module.exports = __webpack_public_path__ + "img/raf-icon.a2a360ac.png";